module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN315_1784287244.c2599dc8.png";